import { render, staticRenderFns } from "./fold4.vue?vue&type=template&id=040f462b&scoped=true&"
import script from "./fold4.vue?vue&type=script&lang=js&"
export * from "./fold4.vue?vue&type=script&lang=js&"
import style0 from "./fold4.vue?vue&type=style&index=0&id=040f462b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f462b",
  null
  
)

export default component.exports